import React from 'react';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import MoldMaintenanceAddEdit from './mold-maintenance-add-edit';

const { MOLDMAINTENANCE_ADD_EDIT } = MODAL_TYPES;

const MoldMaintenaceModals = () => {
  return (
      <>
         <MoldMaintenanceAddEdit modalId={MOLDMAINTENANCE_ADD_EDIT} />
        
       </>
     );
   };
   

export default MoldMaintenaceModals